import React from "react"
import DateHelper from "../DateHelper/DateHelper"

class EditPaymentLogTimeLine extends React.Component {
  
  constructor(props) {
    super(props);
  };

  render() {
    if (this.props.payment_log.payment_type.name === 'cash') {
      return (
        <div className="panel panel-default payment-log-timeline">
          <div className="panel-body container">
            <div className="payment-log-timeline-event">
              <div className="icon"><span className="payment_captured ss-cashregister"></span></div>
              <div className="event-date">
                <div className="event">{I18n.t('cash_received')}</div>
                <div className="date">{DateHelper.parseToDateTimeString(this.props.payment_log.processed_at, this.props.date_format, this.props.time_format)}</div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.props.payment_log.payment_type.name === 'rentals_united'){
      return (
        <div className="panel panel-default payment-log-timeline">
          <div className="panel-body container">
            <div className="payment-log-timeline-event">
              <div className="icon"><span className="payment_captured ss-creditcard"></span></div>
              <div className="event-date">
                <div className="event">{I18n.t('ota_payment')}: {this.props.payment_channel ? this.props.payment_channel.name : I18n.t('rentals_united')}</div>
                <div className="date">{DateHelper.parseToDateTimeString(this.props.payment_log.processed_at, this.props.date_format, this.props.time_format)}</div>
                <div className="date">{I18n.t('ota_payment_disclaimer')}</div>
              </div>
            </div>
          </div>
        </div>
      )
    }else {
      if (this.props.payment_log.payment_type.name === 'voucher') { 
        var timelineClass = function (timeline_event) {
          if (timeline_event == 'payment_captured') {
            return 'payment_captured ss-newspaper';
          } else if (timeline_event == 'payment_refunded') {
            return 'payment_refunded ss-left';
          } else if (timeline_event == 'payment_voided') {
            return 'payment_voided ss-ban';
          } else if (timeline_event == 'payment_failed') {
            return 'payment_failed ss-ban';
          }
        };
      } else {
        var timelineClass = function (timeline_event) {
          if (timeline_event == 'payment_authorized') {
            return 'payment_authorized ss-check';
          } else if (timeline_event == 'payment_captured') {
            return 'payment_captured ss-creditcard';
          } else if (timeline_event == 'payment_refunded') {
            return 'payment_refunded ss-left';
          } else if (timeline_event == 'payment_voided') {
            return 'payment_voided ss-ban';
          } else if (timeline_event == 'payment_failed') {
            return 'payment_failed ss-ban';
          } else if (timeline_event == 'payment_responce_id') {
            return 'payment-response-id ss-badge';
          };
        };
      };

      
      if (this.props.timeline && this.props.timeline.length > 0) {
        var timeline_events = this.props.timeline.map((timeline) => {
          return (
            <div key={timeline['date'] + timeline['event']} className="payment-log-timeline-event">
              <div className="icon"><span className={timelineClass(timeline['event'])}></span></div>
              <div className="event-date">
                <div className="event">{timeline['event'] == 'payment_refunded' ? this.props.formatCurrency(timeline['amount']) + ' ' + I18n.t('refunded') : timeline['event'] == 'payment_failed' ? I18n.t(timeline['event']) + ' - ' + timeline['failed_text'] : timeline['event'] == 'payment_responce_id' ? I18n.t(timeline['event']) + ': ' + timeline['response_id'] : I18n.t(timeline['event'])}</div>
                { timeline['event'] != 'payment_responce_id' ? <div className="date">{DateHelper.parseToDateTimeString(timeline['date'], this.props.date_format, this.props.time_format)}</div> : null }
              </div>
            </div>
          );
        }); 
      };
        return (
          <div className="panel panel-default payment-log-timeline">
            <div className="panel-body">
              {timeline_events}
            </div>
          </div>
        );
    };
  }
};

export default EditPaymentLogTimeLine